import {
  NoResultsBanner,
  PurchaseTable,
  PurchaseTableHeader,
  PurchaseTyreGroupRow,
} from '~/purchase/components';
import { memo } from 'react';
import { IUserCustomer } from '~/common/types';
import {
  IBaseTyreOffer,
  IProductListState,
  ISearchTypeArgs,
} from '~/purchase/types';

type Props = {
  offers: IBaseTyreOffer[];
  customer: IUserCustomer;
  requestedQuantity: number;
  searchType: ISearchTypeArgs['searchType'];
  searchQuery: IProductListState['searchQuery'];
  onUpdateQuery: (tyreOffer: IBaseTyreOffer) => IBaseTyreOffer | undefined;
};
const Offers = ({
  offers,
  customer,
  requestedQuantity,
  searchType,
  searchQuery,
  onUpdateQuery,
}: Props) => {
  return (
    <>
      {offers.length === 0 ? (
        <NoResultsBanner />
      ) : (
        <>
          <PurchaseTable>
            <PurchaseTableHeader />
          </PurchaseTable>
          {offers.map((product) => {
            return (
              <PurchaseTyreGroupRow
                key={product.tyre.ean}
                product={product}
                requestedQuantity={requestedQuantity}
                customer={customer}
                searchType={searchType}
                searchQuery={searchQuery}
                onUpdateQuery={onUpdateQuery}
              />
            );
          })}
        </>
      )}
    </>
  );
};

export default memo(Offers);
